exports.ById = {
  1: { Name: 'Manufacturer', Id: 1, industrialCodeTypeId: 1 },
  2: { Name: 'Distributor', Id: 2, industrialCodeTypeId: 3 },
  3: { Name: 'Service Provider', Id: 3, industrialCodeTypeId: 5 },
  4: { Name: 'Integrated', Id: 4, industrialCodeTypeId: 7 },
  5: { Name: 'Other', Id: 5, industrialCodeTypeId: 9 },
  6: { Name: 'Service Provider - Other', Id: 6, industrialCodeTypeId: 11 },
  7: { Name: 'Distributor - Other', Id: 7, industrialCodeTypeId: 13 },
  8: { Name: 'Retail', Id: 8, industrialCodeTypeId: 15 },
  9: { Name: 'Value Added Distributor', Id: 9, industrialCodeTypeId: 17 },
  10: { Name: 'Non-Value Added Distributor', Id: 10, industrialCodeTypeId: 19 }
};

exports.ByName = {
  Manufacturer: { Name: 'Manufacturer', Id: 1, industrialCodeTypeId: 1 },
  Distributor: { Name: 'Distributor', Id: 2, industrialCodeTypeId: 3 },
  ServiceProvider: { Name: 'Service Provider', Id: 3, industrialCodeTypeId: 5 },
  Integrated: { Name: 'Integrated', Id: 4, industrialCodeTypeId: 7 },
  Other: { Name: 'Other', Id: 5, industrialCodeTypeId: 9 },
  ServiceProviderOther: { Name: 'Service Provider - Other', Id: 6, industrialCodeTypeId: 11 },
  DistributorOther: { Name: 'Distributor - Other', Id: 7, industrialCodeTypeId: 13 },
  Retail: { Name: 'Retail', Id: 8, industrialCodeTypeId: 15 },
  ValueAddedDistributor: { Name: 'Value Added Distributor', Id: 9, industrialCodeTypeId: 17 },
  NonValueAddedDistributor: { Name: 'Non-Value Added Distributor', Id: 10, industrialCodeTypeId: 19 }
};

exports.ByType = {
  Distributor: [2, 7, 8, 9, 10],
  ServiceProvider: [1, 3, 6]
};
